var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiveClass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#E4E4E4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_196_1025)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1168 7.54057H13.6191L15.149 6.15467C15.3274 5.99326 15.3102 5.74505 15.1114 5.60022C14.9126 5.45539 14.6068 5.46935 14.4284 5.63032L12.6723 7.22082C12.3251 7.53534 11.6738 7.53534 11.3267 7.22082L9.57105 5.63075C9.39211 5.46979 9.08741 5.45626 8.88805 5.60066C8.68922 5.74505 8.67256 5.99326 8.85043 6.1551L10.3803 7.54101H7.88315C6.43116 7.54101 5.25 8.49985 5.25 9.67854V16.3625C5.25 17.5412 6.43116 18.5 7.88315 18.5H16.1168C17.5688 18.5 18.75 17.5412 18.75 16.3625V9.67854C18.75 8.49985 17.5688 7.54057 16.1168 7.54057ZM17.7827 16.3625C17.7827 17.108 17.0352 17.7148 16.1168 17.7148H7.88315C6.96477 17.7148 6.21728 17.108 6.21728 16.3625V9.67854C6.21728 8.93302 6.96477 8.32623 7.88315 8.32623H16.1168C17.0352 8.32623 17.7827 8.93302 17.7827 9.67854V16.3625Z",
    fill: "#1B1625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1032 11.9235L12.163 10.7425C11.6939 10.4574 11.0863 10.4205 10.5766 10.6487C10.0663 10.8759 9.75 11.3245 9.75 11.8188V14.1812C9.75 14.676 10.0663 15.1246 10.576 15.3514C10.7986 15.4511 11.0404 15.5 11.2806 15.5C11.5907 15.5 11.8987 15.4183 12.163 15.258L14.1027 14.0766C14.5077 13.83 14.75 13.4277 14.75 13.0007C14.7505 12.5737 14.5087 12.1704 14.1032 11.9235ZM13.5618 13.4169L11.622 14.5983C11.438 14.7111 11.2092 14.7236 11.0081 14.6347C10.808 14.5454 10.6886 14.3761 10.6886 14.1816V11.8193C10.6886 11.6249 10.808 11.4556 11.0086 11.3667C11.0962 11.3271 11.1894 11.3078 11.2822 11.3078C11.401 11.3078 11.5188 11.3397 11.622 11.403L13.5623 12.584C13.7218 12.681 13.8124 12.8327 13.8124 13.0007C13.8124 13.1686 13.7212 13.3204 13.5618 13.4169Z",
    fill: "#1B1625"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_196_1025"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveClass);
export default __webpack_public_path__ + "static/media/live-class.8f50c71fbf5d004f5194cc032a325418.svg";
export { ForwardRef as ReactComponent };